import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

export const useRiskSurveyTranslation = () => useTranslation(FEATURE_NAMESPACE)
